import { render } from "./ImageUploadScreen.vue?vue&type=template&id=787e0ea9"
import script from "./ImageUploadScreen.vue?vue&type=script&lang=js"
export * from "./ImageUploadScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__